import { Close } from "@mui/icons-material";
import { Box } from "@mui/system";
import React from "react";
import { ILightBoxProps } from "./interfaces/ILightBoxProps";
import { useLightBoxStyles } from "./useLightBoxStyles";

export const LightBox: React.FC<ILightBoxProps> = (props) => {
  const { open, images, onClose, variant = "NORMAL" } = props;
  const classes = useLightBoxStyles();

  /* In GALLERY mode, clicking a thumbnail opens that image full-size.
     `activeIndex === null` means the grid is shown. */
  const [activeIndex, setActiveIndex] = React.useState<number | null>(null);

  // Reset the zoomed-in image whenever the lightbox is (re)opened/closed.
  React.useEffect(() => {
    if (!open) setActiveIndex(null);
  }, [open]);

  if (!open) return <></>;

  const showGrid = variant === "GALLERY" && activeIndex === null;
  const activeImage =
    activeIndex !== null ? images[activeIndex] : images[0];

  return (
    <Box className={classes.root}>
      <Box
        className={classes.closeRoot}
        onClick={() => {
          // From a zoomed image in gallery mode, go back to the grid first.
          if (variant === "GALLERY" && activeIndex !== null) {
            setActiveIndex(null);
          } else {
            onClose();
          }
        }}
      >
        <Close className={classes.close} />
      </Box>

      {showGrid ? (
        <Box className={classes.galleryGrid}>
          {images.map((src, index) => (
            <Box
              key={`${src}-${index}`}
              className={classes.galleryItem}
              onClick={() => setActiveIndex(index)}
            >
              <img
                className={classes.galleryImage}
                src={src}
                alt={`Gallery item ${index + 1}`}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Box>
          {images.length > 0 && (
            <img
              className={classes.image}
              src={activeImage}
              alt="LightBox data not found"
            />
          )}
        </Box>
      )}
    </Box>
  );
};
